var exports = {
  "Qs": "ExternalLinkWarningModal.module__content___Ymd3Zk",
  "zc": "ExternalLinkWarningModal.module__iconContainer___Ymd3Zk",
  "kJ": "ExternalLinkWarningModal.module__iconCircle___Ymd3Zk",
  "QW": "ExternalLinkWarningModal.module__warningIcon___Ymd3Zk",
  "FS": "ExternalLinkWarningModal.module__textContainer___Ymd3Zk",
  "DD": "ExternalLinkWarningModal.module__title___Ymd3Zk",
  "h_": "ExternalLinkWarningModal.module__description___Ymd3Zk",
  "VU": "ExternalLinkWarningModal.module__urlSection___Ymd3Zk",
  "A7": "ExternalLinkWarningModal.module__urlLabel___Ymd3Zk",
  "vQ": "ExternalLinkWarningModal.module__urlBox___Ymd3Zk",
  "xG": "ExternalLinkWarningModal.module__urlText___Ymd3Zk",
  "mH": "ExternalLinkWarningModal.module__checkboxLabel___Ymd3Zk",
  "x6": "ExternalLinkWarningModal.module__button___Ymd3Zk",
};

module.exports = exports;
